"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconPremiumPortal = function IconPremiumPortal(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M14.139 4h25.003v2H14.143a4.015 4.015 0 0 0-4.001 4.002V27h32v-9h2v11H9.667l-4.64 7.47a.41.41 0 0 0 .204.514l.004.002.032.014h35.875v2H5.047l-.093-.018a2.409 2.409 0 0 1-1.711-3.42l.022-.046.027-.044 4.85-7.807V9.997A6.015 6.015 0 0 1 14.139 4m-2.997 27v1h28v-1zm-1 4h24v-1h-24zm5-13V10h2v12h2V12h2v10h2v-4h2v4h2v-2h2v2h2v-4h2v4h2v-5h2v5h2v1h-26v-1zm14.504-11.692 3.07.184-2.383 1.925.78 3.025-2.567-1.696-2.567 1.696.78-3.025-2.384-1.925 3.07-.184 1.1-2.933z",
    clipRule: "evenodd"
  })));
};

export { IconPremiumPortal, IconPremiumPortal as default };
